import React, { useEffect } from "react";
import { ThemeProvider } from "./Components/ThemeProvider";

import Navbar from "./Components/Pages/Header/Navbar";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./Components/Pages/Home";
import './App.css'
import AllGalleryPage from "./Components/Pages/Gallery/AllGalleryPage";
import ActivityPage from "./Components/Pages/Activity/ActivityPage";
import ShowActitvityPage from "./Components/Pages/Activity/ShowActitvityPage";
import ShowDoctor from "./Components/Pages/Doctors/ShowDoctor";
import AllDoctorPage from "./Components/Pages/Doctors/AllDoctorPage";
import ShowPublishment from "./Components/Pages/Publishment/ShowPublishment";
import AllPublishment from "./Components/Pages/Publishment/AllPublishment";
import './Components/App/i18n'; // ✅ Import i18n before rendering App
import ShowCase from "./Components/Pages/Cases/ShowCase";
import AllCase from "./Components/Pages/Cases/AllCase";
import BranchPage from "./Components/Pages/BranchPage/BranchPage";
import Project from "./Components/Pages/Projects/Project";
import ShowProject from "./Components/Pages/Projects/ShowProject";
import ShowAboutPage from "./Components/Pages/AboutPage/ShowAboutPage";
import AllActivityPage from "./Components/Pages/Activity/AllActivityPage";
import ZakatPage from "./Components/Pages/Zakat/ZakatPage";
import Unit from "./Components/Pages/UnitPage/Unit";
import ShowUnit from "./Components/Pages/UnitPage/ShowUnit";
import ScrollToTop from "./Components/ScrollToTop";
import BlogPage from "./Components/Pages/BlogPage/BlogPage";
import NotFoundPage from "./Components/Pages/NotFoundPage";
import NeedZadPage from "./Components/Pages/NeedZadPage/NeedZadPage";
import ShowStatistics from "./Components/Pages/Statistics/ShowStatistics";
import ShowBranchInfo from "./Components/Pages/BranchPage/ShowBranchInfo";
import ShowInfo from "./Components/Pages/BranchPage/ShowInfo";
import SearchPage from "./Components/Pages/SearchPage";
import { fetchSettingData } from "./Components/features/Setting/setting";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Loading from "./Components/Pages/Loading";

const App = () => {
  const lang = localStorage.getItem('language') || 'en';
  document.documentElement.setAttribute('dir', lang === 'ar' || lang === 'ckb' ? 'rtl' : 'ltr');
  const dispatch = useDispatch();
  const { settings , loading} = useSelector((state) => state.setting);

  const { i18n } = useTranslation();

  useEffect(() => {
    dispatch(fetchSettingData("hash_tag"));
  }, [dispatch, i18n.language]);
  
  return (
    <ThemeProvider>
      <div className="min-h-screen bg-white dark:bg-zinc-950 text-zinc-900 dark:text-zinc-100 transition-colors duration-200">
        <BrowserRouter>
          <ScrollToTop />
          <Navbar />
          <div className="flex flex-col">
            {/* <Head /> */}
          </div>
        <Routes>
          <Route path="/" element={<Home settings={settings} />} />
          <Route path="/gallery" element={<AllGalleryPage />} />
          <Route path="/zakat" element={<ZakatPage />} />

          <Route path="/activity" element={<AllActivityPage />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/activity/:id" element={<ShowActitvityPage />} />
          <Route path="/doctor" element={<AllDoctorPage />} />
          <Route path="/doctors/:id/:team" element={<ShowDoctor />} />
          <Route path="/show/statistics" element={<ShowStatistics />} />
          <Route path="publication/:id" element={<ShowPublishment />} />
          <Route path="publication" element={<AllPublishment />} />
          <Route path="case/:id" element={<ShowCase />} />
          <Route path="case" element={<AllCase />} />
          <Route path="/branch" element={<BranchPage />} />
          <Route path="/show/info/branch/:id" element={<ShowBranchInfo />} />
          <Route path="/show/info/:id" element={<ShowInfo />} />
          <Route path="/project" element={<Project />} />
          <Route path="/project/:id" element={<ShowProject />} />
          <Route path="/about/:id" element={<ShowAboutPage />} />
          <Route path="/unit" element={<Unit />} />
          <Route path="/unit/:id" element={<ShowUnit />} />
          <Route path="/blog/:id" element={<BlogPage />} />
          <Route path="/need" element={<NeedZadPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </div>
    </ThemeProvider>
  );
};

export default App;
